import i18next from 'i18next'
import filterFirstLowerCaseForSpeciality from 'common/filters/filterFirstLowerCaseForSpeciality'
import type {
  ApiDoctorAppointmentRestrictionsResponse,
  DoctorAppointmentRestrictionsGroup,
} from 'src/components/common/DoctorAppointmentRestrictionsModal/types'

/**
 * Группирует ограничения по специальности для модалки.
 */
export default function mapDoctorAppointmentRestrictions(
  restrictions: ApiDoctorAppointmentRestrictionsResponse,
): DoctorAppointmentRestrictionsGroup[] {
  const options = { ns: i18next.language }

  return restrictions
    .filter(item => item.restrictions_appointment.length)
    .map(item => ({
      title: i18next.t('Как {spec}', {
        ...options,
        spec: filterFirstLowerCaseForSpeciality(item.speciality_name),
      }),
      restrictions: item.restrictions_appointment,
    }))
}
